<template>
    <div>
        <div class="is-pc swiper-container-news">
            <img src="/src/assets/img/common/slider-arrow-prev.png" alt="＜" class="slide-arrow prev-arrow">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(newsitem, index) in newslists" :key=index>
                    <a :href="route(route_list, 'site.news.detail', {id:newsitem.id})">
                        <div class="c-slider-news__img" v-if="isEmpty(newsitem.media_thumbnail_url)">
                            <img src="/src/assets/img/common/dummy-thumbnail-landscape.jpg" alt="" loading="lazy">
                        </div>
                        <div class="c-slider-news__img" v-else>
                            <img :src="newsitem.media_thumbnail_url" alt="" loading="lazy">
                        </div>
                        <div class="c-slider-news__text">
                            <div class="c-slider-news__text-inner">
                                <p class="c-lead-bold">{{ newsitem.title }}</p>
                                <div v-if="newsitem.is_new" class="c-slider-normal__icon">
                                    <div class="c-label-new">New</div>
                                </div>
                                <div class="c-slider-news__text-label">
                                    <p class="c-date">
                                    {{ newsitem.date }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <img src="/src/assets/img/common/slider-arrow-next.png" alt="＞" class="slide-arrow next-arrow">
        </div>
        <div class="is-sp carousel-sp">
            <img src="/src/assets/img/common/slider-arrow-prev.png" alt="＜" class="slide-arrow prev-arrow">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(newsitem, index) in newslists" :key=index>
                    <a :href="route(route_list, 'site.news.detail', { id: newsitem.id })">
                        <div class="c-slider-news__img" v-if="isEmpty(newsitem.media_thumbnail_url)">
                            <img src="/src/assets/img/common/dummy-thumbnail-landscape.jpg" alt="" loading="lazy">
                        </div>
                        <div class="c-slider-news__img" v-else>
                            <img :src="newsitem.media_thumbnail_url" alt="" loading="lazy">
                        </div>
                        <div class="c-slider-news__text">
                            <div class="c-slider-news__text-inner">
                                <p class="c-lead-bold">{{ newsitem.title }}</p>
                                <div v-if="newsitem.is_new" class="c-slider-normal__icon">
                                    <div class="c-label-new">New</div>
                                </div>
                                <div class="c-slider-news__text-label">
                                    <p class="c-date">
                                    {{ newsitem.date }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <img src="/src/assets/img/common/slider-arrow-next.png" alt="＞" class="slide-arrow next-arrow">
        </div>
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';
import Swiper from 'swiper/bundle';
export default {
    props: [
        'newslists',
        'route_list',
    ],
    mixins: [routeMixin],
    mounted: function() {
        // 3項目のため、専用のswiperを用意する
        const swiper = new Swiper('.swiper-container-news', {
            freeMode: {
                enabled: true,
                momentumBounce: true,
            },
            slidesPerView: 3,
            navigation: {
                nextEl: ".next-arrow",
                prevEl: ".prev-arrow",
            },
        });

        const carouselSp = new Swiper('.carousel-sp', {
            freeMode: {
                enabled: true,
                momentumBounce: true,
            },
            slidesPerView: 2.5,
            navigation: {
                nextEl: ".next-arrow",
                prevEl: ".prev-arrow",
            },
        });
    },
    methods:{
        isEmpty(value){
            if(value == ''){
                return true;
            }
            return false;
        }
    }
}
</script>

<style scoped>
.swiper-container-news {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}

.carousel-sp {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}

.c-lead-bold {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-top: 10px;
}
</style>
